import { Injectable, inject } from '@angular/core';
import { SiaPermissionsConfig } from '../interfaces/sia-permissions-config';
import { SiaUserPermissions } from '../interfaces/sia-user-permissions';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaPermissionsApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'componentpermissions';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  applyRule(ruleParams: { componentTypeId: string[]; groupId: string[]; action: string; cloneGroupId: string }) {
    return this.http.post(`${this.apiController}/rule`, ruleParams);
  }

  getPermissions(userId: number, componentId: string): Promise<SiaUserPermissions> {
    return this.http.post(`${this.apiController}/capabilities`, {
      userId,
      componentId,
    });
  }

  createEmptyPermissions(): Promise<any> {
    return this.http.post(`${this.apiController}/create-empty-permissions`, {});
  }

  getPermissionsConfig(): Promise<SiaPermissionsConfig[]> {
    return this.http.get(`${this.apiController}/permissions-config`, {});
  }

  updateRows(rows: SiaPermissionsConfig[]): Promise<boolean> {
    return this.http.post(`${this.apiController}/update-permissions`, rows);
  }
}
